var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 20,
    viewBox: "0 0 81 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.84418V19.9405H0V0Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88086 0H11.7324L20.5019 16.0714H20.5612V0H23.4053V19.9405H19.7909L10.7843 3.57143H10.725V20H7.88086V0Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4414 0H32.2929L41.0625 16.0714H41.1217V0H43.9659V19.9405H40.2922L31.2856 3.57143H31.2263V20H28.4414V0Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1211 0H60.2608V2.5H51.9653V8.33333H59.4905V10.8333H51.9653V17.381H60.2608V19.881H49.1211V0Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4524 2.67857L78.3932 2.55952L76.8526 0.357143L71.816 7.67857L66.5424 0H63.165L69.8014 9.58333L62.5132 19.9405H65.8906L71.579 11.4881L77.4451 19.9405H81.0004L73.6529 9.52381L78.4524 2.67857Z",
    fill: "#009FE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7487 2.32143L80.3486 0H77.0896L78.7487 2.32143Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dae911e46835fc989f0915822aff81e5.svg";
export { ForwardRef as ReactComponent };